export const getInstanceRegion = (instanceRegion: string): string => {
  // Instance region needs processing because sometimes it can be like us-east-1a, eu-central-1b
  // So, we're checking if last segment is 2 characters, we're getting rid of last char
  const regionLastSegment = instanceRegion.split('-').pop();
  if (regionLastSegment?.length === 2) return instanceRegion.slice(0, -1);
  return instanceRegion;
};
